import styled, { css } from 'styled-components';

export type PaginationVariant = 'ghost' | 'solid';

interface VariantProps {
  $variant?: PaginationVariant;
}

export const Pagination = styled.div<{
  $align?: 'left' | 'center' | 'right';
  $variant?: PaginationVariant;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ $align }) =>
    $align === 'left'
      ? 'flex-start'
      : $align === 'center'
        ? 'center'
        : 'flex-end'};
  gap: ${({ $variant }) => ($variant === 'solid' ? '12px' : '16px')};
  height: ${({ $variant }) => ($variant === 'solid' ? '30px' : '28px')};
`;

const ghostButtonStyles = css`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;

  &:disabled {
    opacity: 0.5;
  }

  svg path {
    stroke: white;
  }
`;

const solidButtonStyles = css`
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  border-radius: 6px;

  &:disabled {
    opacity: 0.5;
  }

  svg path {
    stroke: #b3b5bd;
  }
`;

export const PaginationButton = styled.button<VariantProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;

  img {
    width: 100%;
    height: 100%;
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ $variant }) =>
    $variant === 'solid' ? solidButtonStyles : ghostButtonStyles}
`;

export const PageNumbers = styled.div<VariantProps>`
  display: flex;
  gap: ${({ $variant }) => ($variant === 'solid' ? '12px' : '10px')};
  align-items: center;
`;

const ghostPageNumberStyles = css<{ $active?: boolean }>`
  width: 27px;
  height: 27px;
  border-radius: 8px;
  background: ${({ $active }) =>
    $active ? 'rgba(13, 17, 23, 0.6)' : 'transparent'};
  border: ${({ $active }) => ($active ? '1px solid #353535' : 'none')};
  font-weight: 400;
  font-size: 15px;
  color: ${({ $active }) => ($active ? '#ffffff' : '#b3b5bd')};
`;

const solidPageNumberStyles = css<{ $active?: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: ${({ $active }) => ($active ? '#07d993' : 'transparent')};
  border: ${({ $active }) =>
    $active ? 'none' : '1px solid #353535'};
  font-weight: 700;
  font-size: 14px;
  color: ${({ $active }) => ($active ? '#0d1117' : '#b3b5bd')};
`;

export const PageNumber = styled.button<{
  $active?: boolean;
  $variant?: PaginationVariant;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  font-family: 'NanumSquareRound', sans-serif;
  line-height: 1;
  text-align: center;

  &:hover {
    color: ${({ $variant, $active }) =>
      $variant === 'solid' && $active ? '#0d1117' : '#ffffff'};
  }

  ${({ $variant }) =>
    $variant === 'solid' ? solidPageNumberStyles : ghostPageNumberStyles}
`;
